<template>

<div class="modal-mask-pause background-melody">
  <div class="modal-wrapper-pause">
    <div class="modal-container-pause">
      <div class="close tamanhoicon" @click="submit()">
          <img :src="require('@/assets/buttons/newbuttons/melody/close.svg')" />
      </div>
      <div class="modal-header-pause tamanhotitle">
        <slot name="header">
          {{$t('menu.settings.sound')}}
        </slot>
      </div>
      <div class="modal-body-pause">
          <slot name="body">
            <label class="switch">
              <input type="checkbox" @click="soundState()" />
              <span class="slider round"></span>
            </label> 
          </slot>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
    name: "SettingsGame",
    emits: ['closeModal'],
    data() {
        return {
          back:'',
      click:'',
          somOn: true,
      estadoSom:''
        };
    },
    props: {
      somJogoMelodia: Boolean,
    },
    methods: {
      somback(){
      if(this.somOn){
        this.back.play();
      }
    },
    somclick(){
      if(this.somOn){
        this.click.play();
      }
    },
    soundState(){
      console.log("antes: "+this.somOn);
      this.somOn=!this.somOn;
      console.log("depois: "+this.somOn);
      this.selectedSom = this.somOn;
    },
    submit(){
      this.estadoSom=this.somOn
      this.$emit('closeModal', this.estadoSom);
      if(this.somOn){
        this.back.play();
      }
      console.log("submit: "+this.estadoSom);
    }
    },
    created() {
     if (this.som){
       this.somOn=true;
     } else {
       this.somOn=false;
     }
    if (this.som != ''){
      this.somOn = this.som;
      this.selectedSom = this.somOn;

    }  
    console.log("create: "+this.somOn);
  },
      mounted() {
        this.click = new Audio(require('@/assets/sons/click.wav'));
        this.back = new Audio(require('@/assets/sons/back.flac'));     
  }
};
</script>

<style>
</style>
